<div class="wrapper wrapper-content mtv-user-page row hide-list-nav-tabs">
    <div class="ibox mainPartPage">
        <div class="ibox-content">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'User'" [buildings]="userService.buildingsForRead"></filter>
                </div>

                <user-filter></user-filter>

                <div *ngIf="userService.canEdit()" class="col-sm-3">
                    <button (click)="openCreateNew()"
                            type="button"
                            class="btn btn-w-m btn-primary pull-right">
                        <i class="fa fa-plus-circle"></i> New User
                    </button>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <filters-view></filters-view>
                </div>
            </div>

            <tabs-wrapper>
                <tab-item [tabId]="'user'">
                    <div class="table-responsive"
                         [ngClass]="{'sk-loading': userService.spinnerShow}"
                         [class.overflow-hidden]="userService.emptyRowService.emptyRow.length > 0"
                         *ngIf="userService.total !== null">
                        <table class="table table-striped table-hover footable" *ngIf="userService.data.length">
                            <thead>
                            <tr [ngClass]="{'noSort': userService.data.length < 2}">
                                <th (click)="adm.urlService.orderBy('fullName', $event)">
                                    Name <span class="footable-sort-indicator"></span>
                                </th>
                                <th (click)="adm.urlService.orderBy('company.name', $event)">
                                    Company Name <span class="footable-sort-indicator"></span>
                                </th>
                                <th (click)="adm.urlService.orderBy('email', $event)">
                                    Email <span class="footable-sort-indicator"></span>
                                </th>
                                <th (click)="adm.urlService.orderBy('userType', $event)">
                                    User Type <span class="footable-sort-indicator"></span>
                                </th>
                                <th (click)="adm.urlService.orderBy('lastLogin', $event)">
                                    Last Login <span class="footable-sort-indicator"></span>
                                </th>
                                <th (click)="adm.urlService.orderBy('lastActivity.updateAt', $event)">
                                    Last Activity <span class="footable-sort-indicator"></span>
                                </th>
                                <th>Status</th>
                                <th>Assigned Buildings</th>
                                <th *ngIf="userService.canEdit()">Action</th>
                            </tr>
                            </thead>

                    <tbody>
                    <tr *ngFor="let item of userService.data; let index = index" [ngClass]="{'footable-odd': (index % 2 === 0)}">
                        <td>{{item.fullName}}</td>
                        <td>{{item.company && item.company.name}}</td>
                        <td>{{item.email}}</td>
                        <td>{{item.userType && getUserTypeName(item.userType)}}</td>
                        <td>{{item.lastLogin ? (item.lastLogin | date:'dd.MM.yyyy hh:mm a') : '-'}}</td>
                        <td>{{item.lastActivity ? (item.lastActivity.updateAt | date:'dd.MM.yyyy hh:mm a') : '-'}}</td>
                        <td>
                            <i *ngIf="item.realStatus == 'active'" class="icon-check"></i>
                            <i *ngIf="item.realStatus == 'did_not_follow_link'"><img src="../../../../assets/img/pending.png"></i>
                            <i *ngIf="item.realStatus == 'inactive'" class="icon-close"></i>
                            <i class="fa fa-lock" *ngIf="item.isLocked"></i>
                        </td>
                        <td class="hint-td">
                            <buildings [data]="item.buildingsManager"></buildings>
                        </td>
                        <td *ngIf="userService.canEdit()" class="td-action-btn">
                            <user-action-button [data]="item"
                                                (onClick)="onActionClick($event)"
                                                [canDelete]="userService.canDelete()"
                                                *ngIf="userService.account.user.id != item.id || userService.account.isUserAdmin()">
                            </user-action-button>
                        </td>
                    </tr>

                            <tr *ngFor="let item of userService.emptyRowService.emptyRow" style="cursor: default;">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td *ngIf="userService.canEdit()"></td>
                            </tr>
                            </tbody>
                        </table>

                        <div *ngIf="userService.total === 0" class="text-center">
                            <h2>Result Not Found</h2>
                            <a class="text-center">
                                <broad-match-toggle></broad-match-toggle>
                            </a>
                        </div>
                    </div>
                </tab-item>
                <pagination
                    *ngIf="userService.total && userService.urlService.queryParams['page'] && !userService.spinnerShow"
                    [total]="userService.total">
                </pagination>

                <spinner [spinnerShow]="userService.spinnerShow"></spinner>

            </tabs-wrapper>
        </div>
    </div>
</div>

<modal *ngIf="isModalShow" (onClose)="closeModal()" [itemData]="currentItemData" [modalType]="modalType"></modal>
<edit-name-modal *ngIf="isEditNameModalShow" (onClose)="closeModal()" [itemData]="currentItemData"></edit-name-modal>
<reset-password-modal *ngIf="userService.showUserPasswordResetModal"></reset-password-modal>
<history-modal *ngIf="isHistoryModalShow" (onClose)="closeHistoryModal()" [itemData]="currentItemData"></history-modal>
<delete-user-modal *ngIf="userService.isShowDeletePopup"></delete-user-modal>



// WEBPACK FOOTER //
// /app/src/app/views/admin/user/user.component.html